import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadUpdatePhotoMutationAtom = createMutationAtomFactory(
  'trade.loadPhotoUpdate',
  (params: {
    fileId: string;
    notes?: string;
    photoRequirementId?: string;
  }) => ({
    tradeLoadPhotoUpdate: {
      __args: {
        fileId: params.fileId,
        input: {
          ...(params.notes && {
            notes: params.notes,
          }),
          ...(params.photoRequirementId !== undefined && {
            photoRequirementId: params.photoRequirementId,
          }),
        },
      },
      id: true,
      fileName: true,
      fileSize: true,
      mimeType: true,
      status: true,
      uploadUrl: true,
      metadata: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  { showLoadingOverlay: false },
);
